export default __webpack_public_path__ + "static/media/shift2dc_infografica.a38ed5ed.png";